module.exports = "https://static.wanderu.com/ui-react/_next/static/media/de.11d88d2b.svg";